import * as React from "react";
import { useDispatch, useSelector } from "@teamprevent/admin-redux";

import { Button, Form, Loader, Modal } from "semantic-ui-react";

import { IsLoadingButton } from "@teamprevent/common/IsLoadingButton";

import { useForm, FormProvider } from "react-hook-form";

import { zodResolver } from "@hookform/resolvers/zod";

import { CREATE_EMPLOYEERECORD } from "../actiontypes";
import { basePathSelector } from "../selectors";
import { createEmployeeRecord } from "../actions";
import { AppState } from "../model";
import { CustomerState } from "../../customer";

import { employeeRecordSchemaFactory, EmployeeRecordFormModel } from "../schema";
import { useCustomerListModel } from "../../customer/hooks";

import { CreateEmployeeForm } from "./CreateEmployeeForm";

import { push } from "redux-little-router";
type State = AppState & CustomerState;

export const CreateModal: React.FunctionComponent = () => {
    const { handleSubmit, reset, ...methods } = useForm<EmployeeRecordFormModel>({
        resolver: zodResolver(employeeRecordSchemaFactory()),
        defaultValues: {
            dateOfBirth: null,
            gender: ""
        },
        shouldFocusError: true,
        mode: "onBlur"
    });

    const dispatch = useDispatch();
    const open = useSelector((state: State) => state.router.pathname?.endsWith("/create"));
    const basePath = useSelector((state: State) => basePathSelector(state));

    const close = React.useCallback(() => {
        reset();
        dispatch(push(basePath));
    }, [basePath, dispatch, reset]);

    const save = (model: EmployeeRecordFormModel) => dispatch(createEmployeeRecord(model, basePath));
    const { customer, isLoading, isLoaded: isCustomerLoaded } = useCustomerListModel();

    if (isLoading || isCustomerLoaded === false) {
        return <Loader active />;
    }

    return (
        <Modal as={Form} size="small" open={open} onClose={close} onSubmit={handleSubmit(save)} closeOnDimmerClick={false}>
            <FormProvider handleSubmit={handleSubmit} reset={reset} {...methods}>
                <Modal.Header>Create Employee Record</Modal.Header>
                <Modal.Content>
                    <CreateEmployeeForm customer={customer} />
                </Modal.Content>
                <Modal.Actions>
                    <Button onClick={close}>Cancel</Button>
                    <IsLoadingButton requestNames={CREATE_EMPLOYEERECORD} content="Save" type="submit" />
                </Modal.Actions>
            </FormProvider>
        </Modal>
    );
};
